(() => {
  'use strict';
  if (window.avonticIpad135) return;
  window.avonticIpad135 = true;
  const observed = new WeakSet(), requests = new Map();
  async function quote(card) {
    if (!card.isConnected || card.hidden || card.dataset.av135Match !== 'exact') return;
    const href = card.href;
    if (card.dataset.av135Quote === href) return;
    card.dataset.av135Quote = href;
    const url = new URL(href);
    url.searchParams.set('section_id', 'avontic-ipad-quote');
    try {
      if (!requests.has(url.href)) requests.set(url.href, fetch(url.href, {credentials: 'same-origin'}).then(async r => {
        if (!r.ok) throw new Error('Offer unavailable');
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        return JSON.parse(doc.querySelector('[data-av135-quote]')?.textContent || 'null');
      }));
      const result = await requests.get(url.href);
      if (!result || !card.isConnected || card.href !== href) return;
      const price = card.querySelector('.av-ibo__price'), action = card.querySelector('[data-av-bundle-card-action]');
      if (!result.variant) { if (action) action.textContent = 'Review available options'; if(card.hasAttribute('data-av-purchase-offer')) {card.dataset.avPurchaseApproved='false';const delta=card.querySelector('[data-av-purchase-delta]');if(delta)delta.textContent='This combination is unavailable. Review the setup options.'; document.dispatchEvent(new CustomEvent('avontic:purchase-offer-quoted'));} return; }
      if (price) price.textContent = result.price;
      if (card.hasAttribute('data-av-purchase-offer')) {
        let eligibility = {};
        try { eligibility = JSON.parse(card.querySelector('[data-av-offer-eligibility]')?.textContent || '{}'); } catch {}
        const eligible = Object.prototype.hasOwnProperty.call(eligibility, String(result.variant)) && result.available && result.currency === 'USD' && eligibility[String(result.variant)] === result.priceCents;
        card.dataset.avPurchaseApproved = eligible ? 'true' : 'false';
        const root = card.closest('[data-av-purchase-product]');
        let current; try { current = JSON.parse(root?.querySelector('variant-picker script[data-variant]')?.textContent || 'null'); } catch {}
        const delta = card.querySelector('[data-av-purchase-delta]');
        if (delta && current && result.available) {
          const difference = result.priceCents - current.price;
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:result.currency}).format(Math.abs(difference)/100);
          delta.textContent = difference > 0 ? `+${money} for this setup` : difference < 0 ? `${money} less` : 'Same price';
        } else if (delta) {
          delta.textContent = result.available ? 'Review your matching setup.' : 'Sold out for this selection.';
        }
        document.dispatchEvent(new CustomEvent('avontic:purchase-offer-quoted'));
      }
      card.dataset.av135Variant = String(result.variant);
      if (action && !result.available) action.textContent = 'Sold out for this selection';
      const img = card.querySelector('img');
      if (img && result.image) {
        if (result.imageSrcset) {
          img.sizes = img.getAttribute('sizes') || result.imageSizes || '400px';
          img.srcset = result.imageSrcset;
        } else {
          img.removeAttribute('srcset');
        }
        img.src = result.image;
      }
    } catch (_) { requests.delete(url.href); if(card.href!==href)return; delete card.dataset.av135Quote; if(card.hasAttribute('data-av-purchase-offer')) {card.dataset.avPurchaseApproved='error';const delta=card.querySelector('[data-av-purchase-delta]');if(delta)delta.textContent='Review options and confirm the current price.'; document.dispatchEvent(new CustomEvent('avontic:purchase-offer-quoted'));} }
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) quote(entry.target);
  }), {rootMargin: '80px'});
  function refresh() {
    document.querySelectorAll('[data-av135-curated] .av135-card').forEach(card => {
      if (!observed.has(card)) {observed.add(card); observer.observe(card);}
    });
    const root=document.querySelector('[data-av135-curated]');
    if(!root) return;
    document.querySelectorAll('#main a[href*="/products/"],#main a[data-av135-story-target]').forEach(link=>{
      if(link.closest('[data-av-ipad-bundle-options]'))return;
      let target=link.dataset.av135StoryTarget || new URL(link.href,location.href).pathname.split('/products/')[1]?.split('/')[0];
      if(root.dataset.currentHandle==='rhinoguard-armorpro-workforce-360-ipad-case-rhinokeys-pro-keyboard-bundle' && target==='rhinoguard-pro-workforce-elite-ipad-case-backlit-keyboard-wireless-mouse-bundle')target='rhinoguard-armorpro-workforce-elite-ipad-case-backlit-keyboard-mouse-bundle';
      const card=[...root.querySelectorAll('.av135-card')].find(c=>c.dataset.avBundleTarget===target);
      if(card){link.dataset.av135StoryTarget=target;link.href=card.href;}
    });
  }
  document.addEventListener('pointerover', e => { const c=e.target.closest?.('.av135-card'); if(c) quote(c); }, {passive: true});
  document.addEventListener('focusin', e => { const c=e.target.closest?.('.av135-card'); if(c) quote(c); });
  document.addEventListener('avontic:ipad-offers-ready', refresh);
  document.addEventListener('avontic:purchase-fit-ready', () => { refresh(); document.querySelectorAll('[data-av-purchase-offer]').forEach(quote); });
  document.addEventListener('variant:change', () => requestAnimationFrame(() => document.querySelectorAll('[data-av-purchase-offer]').forEach(quote)));
  document.addEventListener('toggle', e => {if(e.target.matches?.('.av135-more') && e.target.open) e.target.querySelectorAll('.av135-card').forEach(quote);},true);
  document.addEventListener('click', e => {
    const story=e.target.closest?.('a[data-av135-story-target]');
    if(story && !story.matches('[data-av-bundle-target]')){const card=[...document.querySelectorAll('[data-av135-curated] .av135-card')].find(c=>c.dataset.avBundleTarget===story.dataset.av135StoryTarget);if(card){e.preventDefault();card.click();return;}}
    const card=e.target.closest?.('.av135-card');
    if(card) window.AvonticAnalytics?.track?.('av_ipad_setup_option_click',{product_handle:card.closest('[data-current-handle]')?.dataset.currentHandle,target_handle:card.dataset.avBundleTarget,offer_type:card.dataset.av135Kind});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true}); else refresh();
  new MutationObserver(records => {if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-av135-curated]')||n.querySelector('[data-av135-curated]'))))) refresh();}).observe(document.documentElement,{childList:true,subtree:true});
})();


(() => {
  if (!document.body.hasAttribute('data-av-ipad-pdp135') || window.avontic14Refinement) return;
  window.avontic14Refinement = true;
  const confirmed = new Map();
  const readFinder = () => {
    const finder = document.querySelector('#avontic-primary-product avontic-pdp-model-finder');
    try { return JSON.parse(finder?.querySelector('[data-av-pdp-model-config]')?.textContent || 'null'); } catch { return null; }
  };
  function updateFit() {
    const config = readFinder();
    if (!config) return;
    const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(config.formId)}"]`);
    const input = picker?.querySelector(`input[data-option-position="${config.optionPosition}"]:checked`);
    const field = input?.closest('fieldset');
    if (!field) return;
    const match = confirmed.get(String(config.productId));
    const valid = match && match.optionId === input.value;
    if (match && !valid) confirmed.delete(String(config.productId));
    field.toggleAttribute('data-av14-fit-confirmed', Boolean(valid));
    const badge = field.querySelector('.av-pdp-required-badge');
    const hint = field.querySelector('.av-pdp-option-guidance');
    if (badge) { const label = valid ? `${badge.dataset.av14Matched} · ${match.model}` : badge.dataset.av14Check; if (label && badge.textContent !== label) badge.textContent = label; }
    if (hint) hint.hidden = Boolean(valid);
  }
  document.addEventListener('avontic:pdp-fit-verification', event => {
    const config = readFinder();
    if (!config || String(config.productId) !== String(event.detail?.productId)) return;
    const input = document.querySelector(`variant-picker[form-id="${CSS.escape(config.formId)}"] input[data-option-position="${config.optionPosition}"]:checked`);
    if (event.detail.verified && input) confirmed.set(String(config.productId), {optionId: input.value, model: event.detail.modelNumber});
    else confirmed.delete(String(config.productId));
    updateFit();
  });
  let pending = false;
  const schedule = () => { if (pending) return; pending = true; requestAnimationFrame(() => {pending = false; updateFit();}); };
  document.addEventListener('variant:change', schedule);
  document.addEventListener('change', event => {if (event.target.closest('variant-picker')) schedule();});
  new MutationObserver(records => {if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('variant-picker') || n.querySelector('variant-picker'))))) schedule();}).observe(document.querySelector('#avontic-primary-product') || document.body, {childList:true,subtree:true});
  const track = (name, details) => window.AvonticAnalytics?.track?.(name, details);
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.av14-accessories') && event.target.open) track('av_ipad_optional_extras_open', {source:'pdp_below_story'});
  }, true);
  document.addEventListener('avontic:optional-extra-added', event => track('av_ipad_optional_extra_added', {source_handle:event.detail?.source,accessory:event.detail?.accessory}));
  updateFit();
})();

